import React from 'react';
import Header from './components/landing/Header';
import HeroSection from './components/landing/HeroSection';
import TrustSignals from './components/landing/TrustSignals';
import ServicesSection from './components/landing/ServicesSection';
import WhyChooseUs from './components/landing/WhyChooseUs';
import RecruitmentSection from './components/landing/RecruitmentSection';
import LocationsSection from './components/landing/LocationsSection';
import TestimonialsSection from './components/landing/TestimonialsSection';
import ContactSection from './components/landing/ContactSection';
import Footer from './components/landing/Footer';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-black">
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <HeroSection />
        <TrustSignals />
        <ServicesSection />
        <WhyChooseUs />
        <RecruitmentSection />
        <LocationsSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
